module.exports = __webpack_public_path__ + "assets/img/manufacturing.e9019bfc.png";